import { useEffect, useState } from 'react';
import { useToast } from '../context/ToastContext';
import '../styles/ErrorBanner.css';
import errorIcon from '../assets/error_icon.svg'; // Just import the file path

const ErrorBanner = () => {
  const { message, clear } = useToast();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (message) {
      setShow(true);
      const timer = setTimeout(() => {
        setShow(false);
        setTimeout(clear, 300);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [message, clear]);

  if (!message || !show) return null;

  const safeMessage = typeof message === 'string' ? message : message?.msg || JSON.stringify(message);

  return (
    <div className="error-banner-container">
      <div className="error-banner">
        <div className="error-left">
          <img src={errorIcon} alt="Error icon" className="error-svg" />
        </div>
        <div className="error-right">
          <button className="error-close" onClick={() => setShow(false)}>
            &times;
          </button>
          <div className="error-title">Error</div>
          <div className="error-message">{safeMessage}</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorBanner;
